import {Component, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { filterActiveUsers, GetUserByAccessLevelFn, mapUserToSearchableSelectItem, UserSelectionValue } from '@portal-workspace/grow-shared-library';
import {
  ApiResponse,
  Application,
  applicationStageAllowSettleLoan,
  isPartyStructureLocked,
  AssetSettlementGetApplicationAssetFn,
  AzureStorageDocument,
  Base64File,
  ConfirmationDialogResult,
  constants,
  DeleteApprovalNoticeFileFn,
  Disbursement,
  DocumentTag,
  DocumentWorklistTableData,
  GenerateApprovalNoticeFn,
  getAllDefaultTags,
  GetApplicationByIdFn,
  getDeposit,
  GetDisbursementByApplicationIdFn,
  GetUserFn,
  GroupedDocument,
  groupStandardCondition,
  Metadata,
  PayloadApiResponse,
  PpsrAsset,
  SelectableTagsDialogResult,
  SendApprovalNoticeEmailFn,
  SettleLoanFn,
  StageNameType,
  TermRateForBusinessOverdraft,
  UpdateApplicationStageInSfFn,
  UploadAzureFile,
  UploadFilesMultiTagsDialogResult,
  User, 
  validateAssetDepositAgainstApplicationDeposit,
  validateAssetDeposits,
  validateDisbursementData,
  DEFAULT_LIMIT,
  DEFAULT_OFFSET,
  DocumentReviewEmailBody,
  GetApplicationSettlementsOfficerFn,
  UpdateApplicationSettlementsOfficerFn,
  UpdateSettlementsOfficerForApplication,
} from '@portal-workspace/grow-shared-library';
import {isInternalUser} from '@portal-workspace/grow-shared-library';
import {CollectionViewer, DataSource, SelectionModel} from '@angular/cdk/collections';
import {BehaviorSubject, combineLatest, Observable, of, Subject, Subscription} from 'rxjs';
import {ApplicationDialogService} from '../application-dialog-component/application-dialog.service';
import {PortalHotToastService} from '../portal-hot-toast-component/hot-toast.service';
import {UntilDestroy} from '@ngneat/until-destroy';
import {getUser, openWindowAndDownloadWithFilename, setupUntilDestroy, applicationDefaultDocuments, CREDIT_STAGES, PRE_DOCS_OUT_STAGES, DOCS_OUT_AND_BEYOND_STAGES, SearchableSelectItem} from '@portal-workspace/grow-ui-library';
import { DataBoxComponent } from '../message-box/data-box.component';
import {getApplicationCustomerName, FINANCE_SALES_EMAIL_DOMAIN, SETTLEMENTS_EMAIL_DOMAIN, GetApplicationPartiesPayload, commercialEntityRoleType, individualRoleType, applicantOf, primaryEntityOf } from '@portal-workspace/grow-shared-library';
import {switchMap, tap} from 'rxjs/operators';
import { EventEmitter } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { defaultDocuments, formGroupedDocumentData, unclassifiedDocuments } from '@portal-workspace/grow-shared-library';
import {loadingFor} from '@ngneat/loadoff';
import { ActivatedRoute } from '@angular/router';
import { DocumentDetailsSubTableComponent } from './document-details-sub-table.component';
import {CustomContentLoaderComponent} from "../custom-content-loader-component/custom-content-loader.component"
import { TagBoxComponent } from '../message-box/tag-box.component';
import { MatTableModule } from '@angular/material/table';
import { ExtendedModule } from '@angular/flex-layout/extended';
import {MatTabsModule} from '@angular/material/tabs';
import { NgClass, AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { CellComponent } from '../application-summary-component/cell.component';
import { SearchableSelectComponent } from '../searchable-select-component/searchable-select.component';

import {
 isExternalUser,
 isAdminOrOperationUser
} from '@portal-workspace/grow-shared-library';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { ApplicationService } from 'apps/portal2/src/app/service/application.service';
import { PpsrService } from 'apps/portal2/src/app/service/ppsr.service';
import { DigitalIdService } from 'apps/portal2/src/app/service/digital-id.service';
import _ from 'lodash';
import { MatCardModule } from '@angular/material/card';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { EditableComponentModule } from '../editable-component/editable-component.module';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { map } from 'rxjs/operators';

export class ApplicationDetailsDocumentDetailsComponentInternalDataSource extends DataSource<GroupedDocument> {

  subject: Subject<GroupedDocument[]> = new BehaviorSubject<GroupedDocument[]>([]);

  connect(collectionViewer: CollectionViewer): Observable<GroupedDocument[]> {
    return this.subject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.subject.complete();
  }

  update(docs: GroupedDocument[]) {
    this.subject.next(docs);
  }
}

export type ListApplicationDocumentFn = (applicationId: number) => Observable<AzureStorageDocument[]>;
export type ListAccreditationDocumentFn = (salesforceId: string) => Observable<AzureStorageDocument[]>;
export type UploadAccreditationDocumentFn = (salesforceId: string, newFiles: Base64File[], deletedFileNames: string[]) => Observable<ApiResponse>;
export type DownloadApplicationDocumentUrlFn = (path: string, fileName: string, applicationId: number) => Observable<Blob>;
export type DownloadAllApplicationDocumentUrlFn = (applicationId: number, customerName: string, userId: number) => Observable<Blob>;
export type ApproveApplicationDocumentFn = (path: string, fileName: string, stateName: string, userId: number | undefined) => Observable<ApiResponse>;
export type DeclineApplicationDocumentFn = (path: string, fileName: string, stateName: string, userId: number | undefined) => Observable<ApiResponse>;
export type UndoApplicationDocumentFn = (path: string, fileName: string, stateName: string, userId: number | undefined) => Observable<ApiResponse>;
export type DeleteApplicationDocumentFn = (path: string, fileName: string, stateName: string) => Observable<ApiResponse>;
export type UpdateApplicationDocumentTagsFn = (path: string, fileName: string, tags: string[]) => Observable<ApiResponse>;
export type UpdateApplicationRequiredDocumentsFn = (applicationId: number, data: DocumentTag[]) => Observable<Application>;
export type DownloadAccreditationDocumentUrlFn = (path: string, fileName: string) => Observable<Blob>;
export type DownloadAllAccreditationDocumentUrlFn = (salesforceId: string, customerName: string, userId: number) => Observable<Blob>;

export type CreateDocumentWorklistFn = (worklist: DocumentWorklistTableData) => Observable<PayloadApiResponse<boolean>>
export type CompleteDocumentWorklistFn = (applicationId: number) => Observable<ApiResponse>;

export interface DocumentDetailsComponentEvent {
  files: File[];
  removefileNames: string[];
  isNonStandardConditionDocument?: boolean;
}

@UntilDestroy({arrayName: 'subscriptions'})
@Component({
    selector: 'document-details',
    templateUrl: './document-details.component.html',
    styleUrls: ['./document-details.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', display: 'block' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: true,
    imports: [FlexModule, MatTabsModule,MatCardModule, NgTemplateOutlet,MatButtonModule, MatTooltipModule, MatFormFieldModule, MatMenuModule, MatDividerModule, CustomContentLoaderComponent, NgClass, ExtendedModule, MatTableModule, TagBoxComponent, DocumentDetailsSubTableComponent, AsyncPipe, MatCheckboxModule,  ReactiveFormsModule, EditableComponentModule, MatSelectModule, MatOptionModule, DataBoxComponent, CellComponent, SearchableSelectComponent]
})
export class DocumentDetailsComponent implements OnInit, OnChanges {
  subscriptions: Subscription[] = [];
  loader = loadingFor('documentDetails');

  dataSource = new ApplicationDetailsDocumentDetailsComponentInternalDataSource();
  dataSourceNonStandardConditions = new ApplicationDetailsDocumentDetailsComponentInternalDataSource();
  dataSourceStandardConditions = new ApplicationDetailsDocumentDetailsComponentInternalDataSource();
  dataSourceCondition: any ;
  salesforceId: string = '';
  limit = DEFAULT_LIMIT;
  offset = DEFAULT_OFFSET;

  docs: GroupedDocument[] = [];
  /** Passed to every sub-table so the tag dialog names guarantors without reading the legacy arrays. */
  parties: GetApplicationPartiesPayload | null = null;
  otherDocs: GroupedDocument[] = [];
  nonStandardConditionDocs: GroupedDocument[] = [];
  standardConditionDocs: GroupedDocument[] = [];
  documentDetails = [];
  formGroupedDocumentData = formGroupedDocumentData;
  unclassifiedDocuments = unclassifiedDocuments;
  getApplicationCustomerName = getApplicationCustomerName;
  applicationDefaultDocuments = applicationDefaultDocuments;
  groupStandardCondition = groupStandardCondition;
  isExternalUser = isExternalUser;
  applicationStageAllowSettleLoan = applicationStageAllowSettleLoan;
  getApplicationSettlementsOfficerFn!: GetApplicationSettlementsOfficerFn
  updateSettlementsOfficer!: UpdateApplicationSettlementsOfficerFn

  @Input({required: true}) apiUrl!: string;
  @Input({required: true}) application!: Application;
  @Input({required: true}) listApplicationDocumentFn!: ListApplicationDocumentFn;
  @Input({required: true}) downloadApplicationDocumentUrlFn!: DownloadApplicationDocumentUrlFn;
  @Input({required: true}) approveApplicationDocumentFn!: ApproveApplicationDocumentFn;
  @Input({required: true}) declineApplicationDocumentFn!: DeclineApplicationDocumentFn;
  @Input({required: true}) undoApplicationDocumentFn!: UndoApplicationDocumentFn;
  @Input({required: true}) deleteApplicationDocumentFn!: DeleteApplicationDocumentFn;
  @Input({required: true}) downloadAllApplicationDocumentUrlFn!: DownloadAllApplicationDocumentUrlFn;
  @Input({required: true}) updateApplicationDocumentTagsFn!: UpdateApplicationDocumentTagsFn;
  @Input({required: true}) updateApplicationRequiredDocumentsFn!: UpdateApplicationRequiredDocumentsFn;
   
  @Input({required: true}) createDocumentWorklistFn!: CreateDocumentWorklistFn;
  @Input({required: true}) completeDocumentWorklistFn!: CompleteDocumentWorklistFn;
  @Input({ required: true }) getUserByAccessLevelFn!: GetUserByAccessLevelFn;

  @Input({required: true}) generateApprovalNoticeFn!: GenerateApprovalNoticeFn;
  @Input({required: true}) sendApprovalNoticeEmailFn!: SendApprovalNoticeEmailFn;
  @Input({required: true}) deleteApprovalNoticeFileFn!: DeleteApprovalNoticeFileFn;
  @Input({required: true}) getUserFn!: GetUserFn;
  @Input({required: true}) getApplicationByIdFn!: GetApplicationByIdFn;
  @Input({required: true}) updateApplicationStageFn!: UpdateApplicationStageInSfFn;
  @Input({required: false}) businessLoanData!: TermRateForBusinessOverdraft;
  @Input({required: false}) isAssetEmpty!: boolean;
  @Input({required: false}) notAllAssetAccepted!: boolean;
  @Input({required: false}) totalNotesCount!: number;
  @Input({required: false}) missingBankDetails!: null | 'customer' | 'broker';
  @Input({required: true}) getApplicationAssetFn!: AssetSettlementGetApplicationAssetFn;
  @Input({required: true}) getDisbursementByApplicationIdFn!: GetDisbursementByApplicationIdFn;
  @Input({required: true}) settleLoanFn!: SettleLoanFn;
   
  @Output() scrollEvent = new EventEmitter<void>();
  @Output() saveNote = new EventEmitter();

  settlementOfficerData: SearchableSelectItem[] = [];
  selectedSettlementOfficer: SearchableSelectItem | null = null;
  defaultSettlementName: string | null = null;

  settlementUsers: SearchableSelectItem[] = [];
  settlementControl = new FormControl<string[]>([]);

  disableAddAsset: boolean = false
  isAssetApplication!: boolean;
  isBusinessApplication!: boolean;
  isCorporateLoanApplication!: boolean;
  assetStatus:PpsrAsset[]=[];
  columnsToDisplay: string[] = ['icon', 'groupName', 'status', 'documents', 'checkBox', 'action'];
  expandedElement!: GroupedDocument | null | undefined;
  expandedElementNonStandardCondition!: GroupedDocument | null | undefined;
  expandedElementStandardCondition!: GroupedDocument | null | undefined;
  dragElement!: GroupedDocument | null | undefined;
  defaultDocuments = defaultDocuments // comes from this.application;
  isInternalUser = isInternalUser;
  Math = Math;
  user: User | null = null;

  loggedInUser: User | null = getUser();
   showCheckboxColumn: boolean = false;
  globalSelected = false; // select all checkboxes
  selection = new SelectionModel<any>(true, []);
  selectedGroupName = new SelectionModel<GroupedDocument>(true, []);
  selectedSettlement: UserSelectionValue | null = null;

  @Output() events = new EventEmitter<DocumentDetailsComponentEvent>();

  constructor(private dialogService: ApplicationDialogService,
    private route: ActivatedRoute,
    private toastService: PortalHotToastService,
    private applicationService: ApplicationService,
    private ppsrService: PpsrService,
    private digitalIdService: DigitalIdService,
  ) { }

  ngOnInit(): void {
    this.loadSettlementUsers();
    // Fetched here and passed down rather than in the sub-table itself, which is instantiated once per
    // expanded document group across three tables and would otherwise fetch per row.
    this.subscriptions.push(
      this.digitalIdService.getApplicationPartiesFn(this.application.ApplicationId)
        .subscribe(payload => this.parties = payload)
    );
  }


  loadSettlementUsers(): void {
    setupUntilDestroy(this);
    this.user = getUser();
    this.updateSettlementsOfficer = this.applicationService.updateSettlementsOfficerFn;

    this.applicationService.getApplicationById(this.application.ApplicationId).pipe(
      tap(r => {
        this.application=r.payload;
        if (this.application.settlmentUserFirstName) {
          
          const settlementOfficerItem: SearchableSelectItem = {
            id: this.application.settlmentUserId?.toString() ?? '',
            label: `${this.application.settlmentUserFirstName} ${this.application.settlmentUserLastName}`.trim(),
            name: `${this.application.settlmentUserFirstName} ${this.application.settlmentUserLastName}`.trim(),
            email: this.application.settlmentUserEmail || null,
            value: this.application.settlmentUserId?.toString() ?? '',
            searchTerm: `${this.application.settlmentUserFirstName} ${this.application.settlmentUserLastName}`.toLowerCase()
          };
          
          this.settlementUsers = [settlementOfficerItem];
          this.settlementControl.setValue([settlementOfficerItem.value]);
        }
      })).subscribe();

    this.subscriptions.push(
      this.getUserByAccessLevelFn('operations').pipe(
        map((users: User[] | null) => {
          const apiUsers = users
            ? users
                .filter((user) => filterActiveUsers(user, true))
                .map((user) => mapUserToSearchableSelectItem(user, false))
            : [];
          
          const currentSettlementId = this.application.settlmentUserId?.toString();
          
          if (apiUsers.length > 0) {
            const filteredApiUsers = currentSettlementId
              ? apiUsers.filter(user => user.value !== currentSettlementId)
              : apiUsers;
            
            this.settlementUsers = this.settlementUsers.length > 0
              ? [...this.settlementUsers, ...filteredApiUsers]
              : filteredApiUsers;
          }
        })
      ).subscribe());
    


  }

  isAdminOrOperationUser() {
    return isAdminOrOperationUser(getUser());
  }
  
  getApplicationAsset() {
    this.subscriptions.push(
      this.getApplicationAssetFn(this.application.ApplicationId).pipe(
        this.toastService.spinnerObservable(),
      ).subscribe((res: PpsrAsset[]) => {
        const stageName = this.application.AppInfoStageName
        if (res.length) {
          if(stageName == 'Closed Won' || stageName == 'Settlement') {
            this.disableAddAsset = false
          }
          this.assetStatus = res.filter(r => r.status === 'accepted');
          if (res.length === this.assetStatus.length) {
            this.notAllAssetAccepted = false
          }
          else {
            this.notAllAssetAccepted = true
          }
        } else {
          this.disableAddAsset = false;
        }
      })
    )
  }

  private displayRequiredDocumentsOnly() {
    this.docs = this.docs.filter(group => {
      if (
        group.value === constants.documentTypes.internalDocuments.value ||
        group.required || group.docs?.length
      ) {
        return true;
      }
      return false;
    })
  }

  private filterInternalDocuments() {
    if (!isInternalUser(this.user)) {
      this.docs = this.docs.filter(group => group.value !== constants.documentTypes.internalDocuments.value);
    }
  }

  get applicationDocumentTypes() {
    const tags = this.application?.DocumentTypes?.length ? this.application?.DocumentTypes.map(t => {
      return {
        ...t,
        value: t.value.toLowerCase()
      }
    }) : [];
    const documentTypes: DocumentTag[] = [];
    for (const tag of tags) {
      if (!documentTypes.map(t => t.value).includes(tag.value)) {
        documentTypes.push(tag)
      }
    }
    return documentTypes;
  }

  reload() {
    switch(this.application?.ApplicationType) {
      case 'AssetFinance':
      case 'Consumer': {
        this.isAssetApplication = true;
        this.isBusinessApplication = false;
        this.isCorporateLoanApplication = false;
        break;
      }
      case 'BusinessLoans':
      case 'BusinessOverdraft': {
        this.isAssetApplication = false;
        this.isBusinessApplication = true;
        this.isCorporateLoanApplication = false;
        break;
      }
      case 'CorporateLoans': {
        this.isAssetApplication = false;
        this.isBusinessApplication = false;
        this.isCorporateLoanApplication = true;
        break;
      }
    }

    this.docs.length = 0;
    this.salesforceId = this.application.AppInfo.SalesforceId ?? '';
    // application.parties, not the async `this.parties` field: the hydrator attaches it from the same
    // snapshot as the legacy arrays, so it is present here synchronously, which the separate fetch is
    // not when reload() runs from ngOnChanges.
    const applicant = applicantOf(this.application.parties);
    const primaryEntity = primaryEntityOf(this.application.parties);

    this.subscriptions.push(
      this.listApplicationDocumentFn(this.application.ApplicationId).pipe(
        this.loader.documentDetails.track(),
        tap((r: AzureStorageDocument[]) => {
          if (r) {
            this.docs = this.formGroupedDocumentData(r,
              this.applicationDocumentTypes?.length ? this.applicationDocumentTypes
                : [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()],
              // Reproduces what the legacy `+` concatenation produced in both directions: the literal
              // "undefined undefined" with no applicant, and a bare space for an applicant with no name
              // recorded. The projections spell a missing name differently ('' against null), so
              // concatenating directly would put "null null" on screen.
              this.application.ApplicationType === "Consumer"
                ? (applicant ? `${applicant.givenName ?? ''} ${applicant.surname ?? ''}` : 'undefined undefined')
                : (primaryEntity?.legalName ?? ""),
            );
            
            this.docs = this.groupStandardCondition(this.docs, this.application);
            this.displayRequiredDocumentsOnly();
            this.filterInternalDocuments();

            this.otherDocs = this.docs.filter(d => d?.otherCondition || (!d?.nonStandardCondition && !d?.standardCondition));
            this.nonStandardConditionDocs = this.docs.filter(d => d?.nonStandardCondition);
            this.standardConditionDocs = this.docs.filter(d => d?.standardCondition);
            this.dataSource.update(this.otherDocs);
            this.dataSourceNonStandardConditions.update(this.nonStandardConditionDocs);
            this.dataSourceStandardConditions.update(this.standardConditionDocs);
            if (this.expandedElement) {
              this.expandedElement = this.otherDocs.find(obj => obj.value === (this.expandedElement as GroupedDocument).value);
            }
            if (this.expandedElementNonStandardCondition) {
              this.expandedElementNonStandardCondition = this.nonStandardConditionDocs.find(obj => obj.value === (this.expandedElementNonStandardCondition as GroupedDocument).value);
            }
            if (this.expandedElementStandardCondition) {
              this.expandedElementStandardCondition = this.standardConditionDocs.find(obj => obj.value === (this.expandedElementStandardCondition as GroupedDocument).value);
            }
          }
        })
      ).subscribe()
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes as any).application) {
      this.reload();
      this.getApplicationAsset()
      
    }
    
  }

  disableSettleLoan($event: boolean){
    this.disableAddAsset = $event
    this.notAllAssetAccepted = $event
  }

  disableOnPPSRStatus($event: boolean){
    this.notAllAssetAccepted = $event
  }
  /**
   * Blob metadata for a dropped file, from the new party shape rather than the legacy arrays.
   *
   * Empty until the parties fetch resolves. The only reader is the drag-and-drop handler, so reaching
   * that would mean dropping a file inside the request's own latency.
   *
   * The `?? ''` coercions are not defensive padding: the legacy projection wrote `''` for a null column,
   * so matching its output means reproducing that rather than emitting `null`.
   */
  get metadata(): Metadata {
    if (!this.parties) {
      return {};
    }
    if (this.application.ApplicationType === 'Consumer') {
      const applicant = this.parties.individuals.find(i => individualRoleType(i) === 'Applicant');
      // With no applicant the previous expression concatenated two undefined values. Preserved as a
      // literal (see the working notes); `dob` is dropped rather than set to undefined, which is what
      // the previous object did and is indistinguishable once serialised.
      return applicant
        ? {
            consumername: `${applicant.givenName ?? ''} ${applicant.surname ?? ''}`,
            dob: applicant.dateOfBirth ?? '',
          }
        : { consumername: 'undefined undefined' };
    }
    const entity = this.parties.commercialEntities.find(e => commercialEntityRoleType(e) === 'Primary');
    if (entity) {
      return {
        legalname: entity.legalName ?? '',
        abn: entity.abn ?? '',
      };
    }

    return {};
  }


  onCopyToClipboardClicked($event: Event) {
    this.toastService.quickInfoToast(`SalesforceId copied to clipboard`);
  }

  onSelectionChanged($event: MatCheckboxChange, element: GroupedDocument) {
    this.globalSelected = false;
    if($event.checked) {
      this.selectedGroupName.select(element)
    } else {
      this.selectedGroupName.deselect(element)
    }
  }

  onSubmitConditionForReview(){
    this.showCheckboxColumn= true
  }

  scrollToNotesPage():void{
    this.scrollEvent.emit();
  }

  onSubmitDocuments(){
    let docs: GroupedDocument[]  = this.groupStandardCondition(this.docs, this.application);
    docs = docs.filter(group => {
      if (
        group.value === constants.documentTypes.internalDocuments.value ||
        group.required || group.docs?.length
      ) {
        return true;
      }
      return false;
    })

    const otherDocs = docs.filter(d => d.otherCondition || (!d?.nonStandardCondition && !d?.standardCondition));
    const nonStandardConditionDocs = docs.filter(d => d?.nonStandardCondition);
    const standardConditionDocs = docs.filter(d => d?.standardCondition);
    const allGroups = [...otherDocs,...nonStandardConditionDocs,...standardConditionDocs].filter(item => item.status !== 'Accepted' );
    
    this.subscriptions.push(
      this.dialogService.openDocumentReviewDialog ({
        title: 'Review Documents/Conditions',
        groupNames:allGroups,
        application: this.application,
        isShowRequestReviewSection:true
      }).afterClosed().pipe(
        tap(async (r) => {
          if(r && r.valid == true){ 
            this.selectedGroupName.clear()
            const groupNameArray:string[] = []
            const pendingTagArray:string[] = []
            const inProgressTagArray:string[] = []
            const submitterEmailList = r.submitterEmailList
            const documentNotes = r.documentNotes
            
            r.groupNames.forEach(element => {
              if(element.status === "Pending"){
                pendingTagArray.push(element.groupName)
              }else if(element.status === "In Progress"){
                inProgressTagArray.push(element.groupName)
              }
              groupNameArray.push(element.groupName)
              this.selectedGroupName.select(element)
            });

            if (isExternalUser(this.loggedInUser) && this.application.AppInfo.StageName && this.application.AppInfoSalesforceID) {
              const stageName = this.application.AppInfo.StageName.toLocaleLowerCase();

              // Simplified routing: Prior to Docs Out -> Finance Sales, From Docs Out onwards -> Settlements
              if (PRE_DOCS_OUT_STAGES.includes(stageName)) {
                // Route to Finance Sales Inbox
                submitterEmailList.push(FINANCE_SALES_EMAIL_DOMAIN);
                // Also notify Credit Officer if assigned and in credit stages
                if (CREDIT_STAGES.includes(stageName) && this.application.creditOfficerEmail) {
                  submitterEmailList.push(this.application.creditOfficerEmail);
                }
                this.sendDocumentReviewEmail(r.isSubmitterSelect,submitterEmailList,documentNotes,pendingTagArray,inProgressTagArray, r.formControlInternalOnly, r.isInternalOnly)
              } else if (DOCS_OUT_AND_BEYOND_STAGES.includes(stageName)) {                
                // Route to Settlements Inbox
                submitterEmailList.push(SETTLEMENTS_EMAIL_DOMAIN);
                this.sendDocumentReviewEmail(r.isSubmitterSelect,submitterEmailList,documentNotes,pendingTagArray,inProgressTagArray, r.formControlInternalOnly, r.isInternalOnly)
              }
            } else {
              if(submitterEmailList.length > 0){
                this.sendDocumentReviewEmail(r.isSubmitterSelect,submitterEmailList,documentNotes,pendingTagArray,inProgressTagArray, r.formControlInternalOnly, r.isInternalOnly)
              }
            }
            
            const notificationSelectedMessage:string[] = [];
            
            if(r.isSubmitterSelect){
              notificationSelectedMessage.push("Submitter")
            }
            if(r.isSalesSelect){
              notificationSelectedMessage.push("Sales")
            }

            if(r.isCreditSelect){
              notificationSelectedMessage.push("Credit")
            }
            if(r.isSettlementSelect){
              notificationSelectedMessage.push("Settlements")
            }


            let notificationSubmitter = ""
            let documentConditionDetail = "";

            if(notificationSelectedMessage.length){
              
              notificationSubmitter = "Notification: "+ notificationSelectedMessage.join(", ")
              
              if(r.otherEmailList.length > 0){
                notificationSubmitter = notificationSubmitter +", "+ r.otherEmailList.join(", ")
              }
            }

            if(groupNameArray.length){
              documentConditionDetail = "Documents/Conditions Review: "+ groupNameArray.join(", ")
            }
            this.onSubmitForReview(r.isAssignWorklist,r.submitterEmailList.length);

            if (!_.isEmpty(documentNotes) || !_.isEmpty(notificationSubmitter) ||  !_.isEmpty(documentConditionDetail)){
              const applicationId = this.route.snapshot.paramMap.get('applicationId') || ''
              const data = {
                UserId: this.loggedInUser?.UserId!,
                ApplicationId: parseInt(applicationId),
                Title: r.noteTitle ?? null,
                Note: documentNotes ?? '',
                visibleToInternalStaff  : r.isInternalUser ?? false,
                notesFromDscrCalculator: true,
                NotificationSubmitter:notificationSubmitter,
                DocumentConditionDetail:documentConditionDetail,
              }
              this.subscriptions.push(this.ppsrService.createNoteFn(data).pipe(
                tap(r => {
                  this.reloadNotes();
                  this.reload();
                })
              ).subscribe())
            }
          }
        })
      ).subscribe()
    )
  }

  reloadNotes(){
    this.saveNote.emit(true);
  }
  
  sendDocumentReviewEmail(isSubmitterSelect:boolean,submitterEmailList:string[],documentNotes:string,pendingTagArray:string[],inProgressTagArray:string[], formControlInternalOnly:boolean, isInternalOnly:boolean) {
    const allEmailList = submitterEmailList;
    const documentReviewEmailBody: DocumentReviewEmailBody = {
      applicationId: this.application.ApplicationId,
      brokerAppId: this.application.BrokerAppId,
      emailList: allEmailList,
      applicationType:this.application.ApplicationType,
      isSubmitterSelect: isSubmitterSelect,
      documentNotes: documentNotes,
      isFromDocumentReview: true,
      pendingTag:pendingTagArray,
      inProgressTag:inProgressTagArray,
      applicationName: this.application.entityName,
      submitterUserId: this.application.UserId,
      salesContact: this.application.opportunityOwnerEmail ?? '',
      formControlInternalOnly: formControlInternalOnly,
      isInternalOnly: isInternalOnly,
    }
    
    this.subscriptions.push(this.applicationService.sendDocumentReviewEmailFn(documentReviewEmailBody).pipe().subscribe())
  }

  oldonSubmitDocuments(){ 
    const selectedGroupNames = this.selectedGroupName.selected
    .filter(item => item.status === 'In Progress');
    if(selectedGroupNames.length){
      this.subscriptions.push(
        this.dialogService.openDocumentReviewDialog ({
          title: 'Review Documents/Conditions',
          groupNames:selectedGroupNames,
          application: this.application,
          isShowRequestReviewSection:true
        }).afterClosed().pipe(
          tap(async (r) => {
            if(r && r.valid == true){
              this.selectedGroupName.clear()
              r.groupNames.forEach(element => {
                this.selectedGroupName.select(element)
              });
            }
          })
        ).subscribe((res)=>{
          if(res){
            this.selectedGroupName.clear()
          }
        })
      )
    }
  }

  onAssetSettleLoan(){
    if (isInternalUser(this.loggedInUser)) {
      this.dialogService.openSettleLoanDialog(true)
        .afterClosed().pipe(
        tap(async (r) => {
          if (r) {
            this.doSendAssetAndDisbursementToSf();
          }
        })
      ).subscribe()
    } else {
      this.dialogService.openSettleLoanDialog(false).afterClosed().pipe(
        tap(async (r) => {
          if (r) {
            // check documents first
            this.subscriptions.push(
              combineLatest([
                this.listApplicationDocumentFn(this.application.ApplicationId),
                this.getApplicationByIdFn(this.application.ApplicationId)
              ]).pipe(
                  this.toastService.spinnerObservable()
                )
                .subscribe(([r, app]: [AzureStorageDocument[], Application]) => {
                if (r) {
                  let docs: GroupedDocument[] = this.formGroupedDocumentData(r,
                    app?.DocumentTypes?.length ? app?.DocumentTypes
                    : [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()],
                    '',
                  );
                  docs = this.groupStandardCondition(docs, this.application);
                  docs = docs.filter(group => {
                    if (
                      group.value === constants.documentTypes.internalDocuments.value ||
                      group.required || group.docs?.length
                    ) {
                      return true;
                    }
                    return false;
                  })

                  const otherDocs = docs.filter(d => d.otherCondition || (!d?.nonStandardCondition && !d?.standardCondition));
                  const nonStandardConditionDocs = docs.filter(d => d?.nonStandardCondition);
                  const standardConditionDocs = docs.filter(d => d?.standardCondition);
                  const pendingGroups = [
                    ...otherDocs.filter(group => (group.status ?? 'Pending') === 'Pending'),
                    ...nonStandardConditionDocs.filter(group => (group.status ?? 'Pending') === 'Pending'),
                    ...standardConditionDocs.filter(group => (group.status ?? 'Pending') === 'Pending')
                  ];
                   
                  if (pendingGroups.length) {
                    // do not allow settle loan
                    this.dialogService.openAlertDialog({
                      message: 'Error',
                      subMessage: 'You cannot request loan settlement when you have pending items on the documents tab.'
                    }).afterClosed().subscribe();
                  } else {
                    this.doUpdateApplicationStage('QA');
                  }
                }
              })
            )
          }
        })
      ).subscribe()

    }
  }

  doSendAssetAndDisbursementToSf(kybRiskAcknowledged?: boolean) {
    if (kybRiskAcknowledged == null && isInternalUser(this.loggedInUser)) {
      this.confirmKybRisk('send settlement details', acknowledged =>
        this.doSendAssetAndDisbursementToSf(acknowledged));
      return;
    }
    this.subscriptions.push(
      combineLatest([
        this.getApplicationAssetFn(this.application.ApplicationId),
        this.getDisbursementByApplicationIdFn(this.application.ApplicationId)
      ]).pipe(
        switchMap(([assets, disbursements]: [PpsrAsset[], Disbursement[]]) => {
          // WEB-3702
          // validate asset(s) individual deposit
          const {valid: assetDepositValid, messages} = validateAssetDeposits(assets);
          if (!assetDepositValid) {
            return of ({
              status: false,
              message: messages.join('<br/>')
            })
          }

          // WEB-3702
          // validate asset(s) deposit against application's deposit
          const appDeposit = getDeposit(this.application);
          const {totalDeposit, applicationDeposit, valid: applicationDepositValid} = validateAssetDepositAgainstApplicationDeposit(Number(appDeposit), assets);
          if (!applicationDepositValid) {
            return of ({
              status: false,
              message: `Application deposit $${applicationDeposit} doesn't match with total asset deposit $${totalDeposit}`,
            });
          }

          // validate disbursements
          if (!validateDisbursementData(disbursements)) {
            return of({
              status: false,
              message: "Please make sure you enter payment details for all disbursements."
            })
          }
           
          return this.settleLoanFn({
            assets: assets,
            disbursements: disbursements,
            salesforceId: this.application.AppInfoSalesforceID ?? "",
            kybRiskAcknowledged: kybRiskAcknowledged === true,
          })
        }),
        this.toastService.spinnerObservable(),
      ).subscribe((response: ApiResponse) => {
        if (response?.status) {
          this.dialogService.successDialog({
            message: "Success",
            subMessage: "Asset and disbursement details sent to Salesforce",
          }).afterClosed().subscribe()
        } else {
          this.dialogService.openAlertDialog({
            message: "Error",
            subMessage: response.message,
          }).afterClosed().subscribe()
        }

      })
    )
  }

  doUpdateApplicationStage(stageName: string, notification = true) {
    if (!stageName) {
      return;
    }
    if (isPartyStructureLocked(stageName as StageNameType) && isInternalUser(this.loggedInUser)) {
      this.subscriptions.push(this.applicationService.getKybRiskStatusFn(this.application.ApplicationId).pipe(
        this.toastService.spinnerObservable(),
      ).subscribe({
        next: risk => {
          if (!risk.requiresAcknowledgement) {
            this.updateApplicationStage(stageName, notification, false);
            return;
          }
          this.dialogService.openConfirmationDialog({
            message: 'Unresolved KYB risk',
            subMessage:
              `${risk.unresolvedEntityCount} business entity(ies) still have unresolved KYB or reconciliation. ` +
              `Continue to ${stageName}? Your acknowledgement will be recorded.`,
          }).afterClosed().subscribe(result => {
            if (result?.readyForSubmission) {
              this.updateApplicationStage(stageName, notification, true);
            }
          });
        },
        error: () => this.dialogService.openAlertDialog({
          message: 'Unable to continue',
          subMessage: 'KYB risk could not be checked. Please try again.',
        }),
      }));
      return;
    }
    this.updateApplicationStage(stageName, notification, false);
  }

  private updateApplicationStage(
    stageName: string,
    notification: boolean,
    kybRiskAcknowledged: boolean,
  ): void {
    this.subscriptions.push(
      this.updateApplicationStageFn({
        salesforceId: this.application.AppInfoSalesforceID ?? '',
        stageName,
        kybRiskAcknowledged,
      }).pipe(
        this.toastService.spinnerObservable(),
      ).subscribe((response: ApiResponse) => {
        if (response.status) {
          if (notification) {
            this.dialogService.successDialog({
              message: 'Success',
              subMessage: `Application sent to ${stageName} queue`,
            }).afterClosed().subscribe();
          }
          setTimeout(() => {
            this.getApplicationByIdFn(this.application.ApplicationId).subscribe((application: Application) => {
              this.application = application as any;
            });
          }, 3000);
        } else {
          this.dialogService.openAlertDialog({
            message: 'Error',
            subMessage: response.message,
          }).afterClosed().subscribe();
        }
      }),
    );
  }

  onCorporateLoanSettleLoan() {
    // similar to Business Term Loan
    this.onBusinessSettleLoan();
  }

  onBusinessSettleLoan(){
    if (isInternalUser(this.loggedInUser)) {
      this.dialogService.openSettleLoanDialog()
        .afterClosed().pipe(
        tap(async (r) => {
          if (r) {
            this.doSendDisbursementToSf();
          }
        })
      ).subscribe()
    } else {
      // check documents first
      this.subscriptions.push(
        combineLatest([
          this.listApplicationDocumentFn(this.application.ApplicationId),
          this.getApplicationByIdFn(this.application.ApplicationId)
        ]).pipe(
          this.toastService.spinnerObservable()
        ).subscribe(([r, app]: [AzureStorageDocument[], Application]) => {
          if (r) {
            let docs: GroupedDocument[] = this.formGroupedDocumentData(r,
              app?.DocumentTypes?.length ? app?.DocumentTypes
              : [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()],
              '',
            );
            docs = this.groupStandardCondition(docs, this.application);
            docs = docs.filter(group => {
              if (
                group.value === constants.documentTypes.internalDocuments.value ||
                group.required || group.docs?.length
              ) {
                return true;
              }
              return false;
            })
            const otherDocs = docs.filter(d => d.otherCondition || (!d?.nonStandardCondition && !d?.standardCondition));
            const nonStandardConditionDocs = docs.filter(d => d?.nonStandardCondition);
            const standardConditionDocs = docs.filter(d => d?.standardCondition);
            const pendingGroups = [
              ...otherDocs.filter(group => (group.status ?? 'Pending') === 'Pending'),
              ...nonStandardConditionDocs.filter(group => (group.status ?? 'Pending') === 'Pending'),
              ...standardConditionDocs.filter(group => (group.status ?? 'Pending') === 'Pending')
            ];
             
            if (pendingGroups.length) {
              // do not allow settle loan
              this.dialogService.openAlertDialog({
                message: 'Error',
                subMessage: 'You cannot settle loan as you still have pending documents',
              }).afterClosed().subscribe();
            } else {
              this.doUpdateApplicationStage('QA');
            }
          }
        })
      )
    }
  }

  doSendDisbursementToSf(kybRiskAcknowledged?: boolean) {
    if (kybRiskAcknowledged == null && isInternalUser(this.loggedInUser)) {
      this.confirmKybRisk('send settlement details', acknowledged =>
        this.doSendDisbursementToSf(acknowledged));
      return;
    }
    this.subscriptions.push(
      this.getDisbursementByApplicationIdFn(this.application.ApplicationId).pipe(
        switchMap((disbursements: Disbursement[]) => {
          // validate disbursements
          if (!validateDisbursementData(disbursements)) {
            return of({
              status: false,
              message: "Please make sure you enter payment details for all disbursements."
            })
          }
          return this.settleLoanFn({
            assets: [],
            disbursements: disbursements,
            salesforceId: this.application.AppInfoSalesforceID ?? "",
            kybRiskAcknowledged: kybRiskAcknowledged === true,
          })
        }),
        this.toastService.spinnerObservable(),
      ).subscribe((response: ApiResponse) => {
        if (response?.status) {
          this.dialogService.successDialog({
            message: "Success",
            subMessage: "Asset and disbursement details sent to Salesforce",
          }).afterClosed().subscribe()
        } else {
          this.dialogService.openAlertDialog({
            message: "Error",
            subMessage: response.message,
          }).afterClosed().subscribe()
        }
      })
    )
  }

  private confirmKybRisk(actionLabel: string, continuation: (acknowledged: boolean) => void): void {
    this.subscriptions.push(this.applicationService.getKybRiskStatusFn(this.application.ApplicationId).pipe(
      this.toastService.spinnerObservable(),
    ).subscribe({
      next: risk => {
        if (!risk.requiresAcknowledgement) {
          continuation(false);
          return;
        }
        this.dialogService.openConfirmationDialog({
          message: 'Unresolved KYB risk',
          subMessage:
            `${risk.unresolvedEntityCount} business entity(ies) still have unresolved KYB or reconciliation. ` +
            `Continue to ${actionLabel}? Your acknowledgement will be recorded.`,
        }).afterClosed().subscribe(result => {
          if (result?.readyForSubmission) {
            continuation(true);
          }
        });
      },
      error: () => this.dialogService.openAlertDialog({
        message: 'Unable to continue',
        subMessage: 'KYB risk could not be checked. Please try again.',
      }),
    }));
  }


  onDownloadAll() {
    const customerName = this.getApplicationCustomerName(this.application)
    const applicationId = this.application.ApplicationId
    const appId = 'G' + '0'.repeat((7 - String(applicationId).length)) + String(applicationId);
    this.downloadAllApplicationDocumentUrlFn(
      applicationId,
      customerName,
      (this.user)?.UserId ?? 0
    ).pipe(
      this.toastService.loadingWithMessage('Downloading...'),
      tap(blob => {
        openWindowAndDownloadWithFilename(customerName + '-' + appId + '.zip', blob)
      })
    ).subscribe()
  }
  
  onUploadDocument(fileType?: string) {
    const allTags: DocumentTag[] = this.applicationDocumentTypes?.length
      ? [...this.applicationDocumentTypes]
      : [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()];
    for (const tag of applicationDefaultDocuments(this.application, true)) {
      if (!allTags.find(t => t.value === tag.value)) {
        allTags.push(tag);
      }
    }

    this.subscriptions.push(this.dialogService.openUploadFileMultiTagsDialog({
      title: 'Upload document',
      tags: fileType ? [fileType] : [],
      allTags: allTags
    }).afterClosed().pipe(
      tap((r: UploadFilesMultiTagsDialogResult | undefined) => {
        if (r) {
          const files = r.files;
          if (files && files.length && r.valid) {
            const isNonStandardConditionDocument = r?.selectedTags.find((item)=>item.nonStandardCondition)?.nonStandardCondition;
            this.events.emit({
              files, removefileNames: [], isNonStandardConditionDocument
            });
          }

          // need to double-check the tags
          const selectedTagNames = r.files.map(file => file.tags).reduce((a, b) => [...(a ?? []), ...(b ?? [])], []) ?? [];
          const tagOptions = ([...Object.values(constants.documentTypes), this.unclassifiedDocuments()] as DocumentTag[]);
          const selectedTags = selectedTagNames.map(
            name => tagOptions.find(tag => tag.value === name)
          ).filter(tag => !!tag) as DocumentTag[];
          const existingTags = this.applicationDocumentTypes?.length ?
            this.applicationDocumentTypes : [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()];

          let tagChanges = false;
          for (const tag of selectedTags) {
            if (!existingTags.map(t => t.type).includes(tag.type)) {
              existingTags.push(tag);
              tagChanges = true;
            }
          }

          if (tagChanges) {
            this.updateApplicationRequiredDocumentsFn(
              this.application.ApplicationId,
              existingTags
            ).subscribe();
          }
        }
      })
    ).subscribe());
  }

  onApproveDocument(docs: AzureStorageDocument[], conditionName: string, type: 'standardCondition' | 'nonStandardCondition' | 'otherCondition') {
    console.log('onApproveDocument', this.application.DocumentTypes, docs, conditionName, type);
    
    // Filter documents that are "In Progress" for this condition
    const inProgressDocs = docs.filter(doc => {
      const docTags = Object.values(doc?.tags ?? {});
      const hasConditionTag = docTags.includes(conditionName);
      const docStatus = doc?.metadata?.[conditionName];
      return hasConditionTag && docStatus === 'In Progress';
    });

    // Approve all "In Progress" documents first
    const approveObservables = inProgressDocs.map(doc => 
      this.approveApplicationDocumentFn(doc.name, "", conditionName, this.loggedInUser?.UserId)
    );

    // If there are documents to approve, wait for all approvals to complete
    if (approveObservables.length > 0) {
      this.subscriptions.push(
        combineLatest(approveObservables).pipe(
          this.toastService.retryableMessage({
            successMessage: `${inProgressDocs.length} document(s) auto-approved`,
            errorMessage: 'Failed to approve some documents',
            retryFn: () => {
              console.log('**** retry ', this);
              this.onApproveDocument(docs, conditionName, type);
            }
          }),
          switchMap(() => {
            // After documents are approved, update the condition status
            return this.updateConditionStatus(conditionName, type);
          })
        ).subscribe()
      );
    } else {
      // No documents to approve, just update the condition status
      this.subscriptions.push(
        this.updateConditionStatus(conditionName, type).subscribe()
      );
    }
  }

  private updateConditionStatus(conditionName: string, type: 'standardCondition' | 'nonStandardCondition' | 'otherCondition'): Observable<Application> {
    const tags: DocumentTag[] = this.application.DocumentTypes ?? [];
    const index = tags.findIndex(t => t.value === conditionName);
    const tagObj = tags.find(t => t.value === conditionName);
    
    if (type) {
      if (tagObj) {
        if (type === 'nonStandardCondition') {
          tags[index] = {...tagObj, nonStandardCondition: true, status: "Accepted"}
        } else if (type === 'standardCondition') {
          tags[index] = {...tagObj, standardCondition: true, status: "Accepted"}
        } else if (type === 'otherCondition') {
          tags[index] = {...tagObj, otherCondition: true, status: "Accepted"}
        }
      } else {
        if (type === 'nonStandardCondition') {
          const group = this.nonStandardConditionDocs.find(g => g.value === conditionName);
          if (group) {
            tags.push({
              type: group.groupName,
              value: group.value,
              description: group.description,
              required: group.required,
              nonStandardCondition: true,
              status: "Accepted"
            })
          }
        } else if (type === 'standardCondition') {
          const group = this.standardConditionDocs.find(g => g.value === conditionName);
          if (group) {
            tags.push({
              type: group.groupName,
              value: group.value,
              description: group.description,
              required: group.required,
              standardCondition: true,
              status: "Accepted"
            })
          }
        } else if (type === 'otherCondition') {
          const group = this.otherDocs.find(g => g.value === conditionName);
          if (group) {
            tags.push({
              type: group.groupName,
              value: group.value,
              description: group.description,
              required: group.required,
              otherCondition: true,
              status: "Accepted"
            })
          }
        }
      }
    }
    
    return this.updateApplicationRequiredDocumentsFn(
      this.application.ApplicationId,
      tags
    ).pipe(
      tap((a: Application) => {
        this.application = a;
        this.reload();
      })
    );
  }

  onDeclineDocument(docs: AzureStorageDocument[], statusName: string, type: 'standardCondition' | 'nonStandardCondition' | 'otherCondition') {
    const tags: DocumentTag[] = this.application.DocumentTypes ?? [];
    const index = tags.findIndex(t => t.value === statusName);
    const tagObj = tags.find(t => t.value === statusName);
    if (type) {
      if (tagObj) {
        if (type === 'nonStandardCondition') {
          tags[index] = {...tagObj, standardCondition: true, status: "Rejected"}
        } else if (type === 'standardCondition') {
          tags[index] = {...tagObj, standardCondition: true, status: "Rejected"}
        } else if (type === 'otherCondition') {
          tags[index] = {...tagObj, otherCondition: true, status: "Rejected"}
        }
      } else {
        if (type === 'nonStandardCondition') {
          const group = this.nonStandardConditionDocs.find(g => g.value === statusName);
          if (group) {
            tags.push({
              type: group.groupName,
              value: group.value,
              description: group.description,
              required: group.required,
              nonStandardCondition: true,
              status: "Rejected"
            })
          }
        } else if (type === 'standardCondition') {
          const group = this.standardConditionDocs.find(g => g.value === statusName);
          if (group) {
            tags.push({
              type: group.groupName,
              value: group.value,
              description: group.description,
              required: group.required,
              standardCondition: true,
              status: "Rejected"
            })
          }
        } else if (type === 'otherCondition') {
          const group = this.otherDocs.find(g => g.value === statusName);
          if (group) {
            tags.push({
              type: group.groupName,
              value: group.value,
              description: group.description,
              required: group.required,
              otherCondition: true,
              status: "Rejected"
            })
          }
        }
      }
      this.updateApplicationRequiredDocumentsFn(
        this.application.ApplicationId,
        tags
      ).subscribe((a: Application) => {
        this.application = a;
        this.reload();
      });
    }
  }

  onUndoDocument(docs: AzureStorageDocument[], statusName: string, type: 'standardCondition' | 'nonStandardCondition' | 'otherCondition') {
    const tags: DocumentTag[] = this.application.DocumentTypes ?? [];
    const index = tags.findIndex(t => t.value === statusName);
    const tagObj = tags.find(t => t.value === statusName);
    if (type) {
      if (tagObj) {
        if (type === 'nonStandardCondition') {
          tags[index] = {...tagObj, standardCondition: true, status: "Pending"}
        } else if (type === 'standardCondition') {
          tags[index] = {...tagObj, standardCondition: true, status: "Pending"}
        } else if (type === 'otherCondition') {
          tags[index] = {...tagObj, otherCondition: true, status: "Pending"}
        }
      } else {
        if (type === 'nonStandardCondition') {
          const group = this.nonStandardConditionDocs.find(g => g.value === statusName);
          if (group) {
            tags.push({
              type: group.groupName,
              value: group.value,
              description: group.description,
              required: group.required,
              nonStandardCondition: true,
              status: "Pending"
            })
          }
        } else if (type === 'standardCondition') {
          const group = this.standardConditionDocs.find(g => g.value === statusName);
          if (group) {
            tags.push({
              type: group.groupName,
              value: group.value,
              description: group.description,
              required: group.required,
              standardCondition: true,
              status: "Pending"
            })
          }
        } else if (type === 'otherCondition') {
          const group = this.otherDocs.find(g => g.value === statusName);
          if (group) {
            tags.push({
              type: group.groupName,
              value: group.value,
              description: group.description,
              required: group.required,
              otherCondition: true,
              status: "Pending"
            })
          }
        }
      }
      this.updateApplicationRequiredDocumentsFn(
        this.application.ApplicationId,
        tags
      ).subscribe((a: Application) => {
        this.application = a;
        this.reload();
      });
    }
  }

  onDeleteDocument(tagName: string, groupName: string) {
    this.subscriptions.push(
      this.dialogService.openConfirmationDialog({
        message: 'Please confirm',
        subMessage: 'Are you sure you want to delete ' + (groupName ?? 'this tag') + '?'
      }).afterClosed().pipe(
        tap(async (r: ConfirmationDialogResult | undefined) => {
          if (r && r.readyForSubmission) {
            const currentTags = this.applicationDocumentTypes?.length ? this.applicationDocumentTypes :
              [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()];
            const tags = currentTags.filter(t => t.value !== tagName);
            this.updateApplicationRequiredDocumentsFn(
              this.application.ApplicationId,
              tags ?? []
            ).pipe(
              this.toastService.retryableMessage({
                successMessage: 'Documents Deleted',
                errorMessage: 'Failed to delete the documents',
                retryFn: ()=> {
                  console.log('**** retry ', this);
                  this.onDeleteDocument(tagName, groupName);
                }
              })
            ).subscribe((a) => {
              this.application = a;
              this.reload();
            })
          }
        })
      ).subscribe()
    );
  }

  async onDownloadDocument(doc: AzureStorageDocument) {
    this.downloadApplicationDocumentUrlFn(doc.name, "", 0).pipe(
      this.toastService.loadingWithMessage('Downloading...'),
      tap(blob => {
        openWindowAndDownloadWithFilename((doc.metadata as Metadata)?.['name'] ?? doc.name, blob)
      })
    ).subscribe()
  }

  getColumnTitles(column: string, table: 'major' | 'standard condition' | 'non-standard condition' = 'major'): string {
    switch (column) {
      case 'groupName':
        return table === 'major' ? 'Other Documents' : (
          table === 'standard condition' ? 'Standard Condition' : 'Non-standard Condition'
        );
      case 'status': return 'Status';
      case 'documents': return 'Documents';
      case 'checkBox': return '';
      case 'action': return '';
      case 'icon': return '';
      default: return column;
    }
  }

  onRequestAdditionalDoc() {
    const requiredTags: DocumentTag[] = this.applicationDocumentTypes?.length
      ? this.applicationDocumentTypes.filter(t => t.required)
      : applicationDefaultDocuments(this.application).filter(t => t.required);
    const dbTags: DocumentTag[] = this.applicationDocumentTypes?.length
      ? [...this.applicationDocumentTypes]
      : [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()];
    let allTags: DocumentTag[] = this.applicationDocumentTypes?.length
      ? [...this.applicationDocumentTypes]
      : [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()];
    for (const tag of applicationDefaultDocuments(this.application, true)) {
      if (!allTags.find(t => t.value.toLowerCase() === tag.value)) {
        allTags.push(tag);
      }
    }

    const standardConditionValues = this.standardConditionDocs.map(s => s.value);
    allTags = allTags.filter(t => !standardConditionValues.includes(t.value));

    this.dialogService.openSelectableTagsDialog({
      previouslySelectedTags: requiredTags,
      allTags,
      maxTags: 100,
      enableCustomTag: true,
      enableNonStandardCondition: true,
    }).afterClosed().pipe(
      tap((r: SelectableTagsDialogResult | undefined) => {
        if (r && r.valid) {
          const tags = r.selectedTags.map((tag) => {tag.required = true; return tag;}) ?? [];
          dbTags.forEach((tag) => {
            if (!tags.find((t) => t.value == tag.value)) {
              tag.required = false;
              tags.push(tag);
            }
          });
          this.updateApplicationRequiredDocumentsFn(
            this.application.ApplicationId,
            tags
          ).subscribe((a) => {
            this.application = a;
            this.reload();
          });
        }
      })
    ).subscribe();
  }

  onSubmitForReview(submitted:boolean,notification:number) {

    if(submitted){
      let successMessage = "Submitted"
        if(notification){
          successMessage=`Submitted, notification email to ${notification} recipients`
        }
      this.subscriptions.push(
        this.createDocumentWorklistFn({
          applicationId: this.application.ApplicationId,
          createdTime: new Date(),
          userId: null,
          status: 'pending',
          entityName: this.application.entityName,
          brokerAppId: this.application.BrokerAppId
        }).pipe(
          this.toastService.retryableMessage({
            successMessage: successMessage,
            errorMessage: 'Failed to submit for review',
            retryFn: ()=> {
              console.log('**** retry ', this);
              this.createDocumentWorklistFn({
                applicationId: this.application.ApplicationId,
                createdTime: new Date(),
                userId: null,
                status: 'pending',
                entityName: this.application.entityName,
                brokerAppId: this.application.BrokerAppId
              })
            }
          })
        ).subscribe()
      )
    }

    if(!submitted && notification){
      this.toastService.simpleSuccess(`Notification email to ${notification} recipients`)
    }
    
    
  }

  onComplete() {
    this.subscriptions.push(
      this.completeDocumentWorklistFn(this.application.ApplicationId).pipe(
        this.toastService.retryableMessage({
          successMessage: 'Removed from the worklist',
          errorMessage: 'Failed to complete the worklist',
          retryFn: ()=> {
            console.log('**** retry ', this);
            this.completeDocumentWorklistFn(this.application.ApplicationId)
          }
        }),
      ).subscribe()
    )
  }

  onDragOver(event: DragEvent, element: GroupedDocument) {
    event.preventDefault();
    this.dragElement = element;
  }

  onDrop(event: DragEvent, element: GroupedDocument, isNonStandardConditionDocument: boolean = false) {
    event.preventDefault();
    this.dragElement = null;
    const files = event.dataTransfer?.files;
    const fileArray = [];
    if (files && files.length > 0) {
      for (const f of Array.from(files)) {
        (f as UploadAzureFile).tags = [element.value];
        (f as UploadAzureFile).metadata = this.metadata;
        fileArray.push(f);
      }

      this.events.emit({
        files: fileArray, removefileNames: [], isNonStandardConditionDocument
      });

      // need to double-check the tags
      const currentTag = getAllDefaultTags().find(t => t.value === element.value);
      const selectedTags = currentTag ? [currentTag] : [] ;
      const existingTags = this.applicationDocumentTypes?.length ?
        this.applicationDocumentTypes : [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()];
      let tagChanges = false;
      for (const tag of selectedTags) {
        if (!existingTags.map(t => t.type).includes(tag.type)) {
          existingTags.push(tag);
          tagChanges = true;
        }
      }

      if (tagChanges) {
        this.updateApplicationRequiredDocumentsFn(
          this.application.ApplicationId,
          existingTags
        ).subscribe();
      }
    }
  }

  onSendApprovalNotice() {
    this.subscriptions.push(
      this.dialogService.openApprovalNoticeDialog({
        application: this.application,
        generateApprovalNoticeFn: this.generateApprovalNoticeFn,
        sendApprovalNoticeEmailFn: this.sendApprovalNoticeEmailFn,
        deleteApprovalNoticeFileFn: this.deleteApprovalNoticeFileFn,
        getUserFn: this.getUserFn,
        apiUrl: this.apiUrl,
        standardCondition: this.standardConditionDocs,
        nonStandardCondition: this.nonStandardConditionDocs,
        businessLoanData: this.businessLoanData,
      }).afterClosed().subscribe()
    )
  }

  get moreActionTooltips() {
    let text = "Find here additional action as: \n";
    if (!isInternalUser(this.user)){
      text += " - Download All as ZIP";
    } else {
      text += " - Download All as ZIP\n - Request Additional Docs\n - Send Notification\n - Complete\n - Approval Notice";
    }
    return text;
  }

  onSettlementOfficerSelected(value: SearchableSelectItem[] | null) {
    
    const data: UpdateSettlementsOfficerForApplication = {
      settlmentUserId: value ? Number(value[0]?.value) : null,
      applicationId: this.application.ApplicationId
    }

    const updateSettlementsOfficerEmailApiCall = this.updateSettlementsOfficer(data)
      .pipe(this.toastService.spinnerObservable(),
        this.toastService.snackBarObservable('Settlement Officer updated successfully')
      );

    this.subscriptions.push(
      updateSettlementsOfficerEmailApiCall.subscribe()
    )

    this.reloadApplication(true);
  }

  reloadApplication(reload: boolean) {
    this.subscriptions.push(this.applicationService.getApplicationById(this.application.ApplicationId).pipe(
      tap(r => {
        if (r.status) {
          this.application = r.payload;
        }
      })
    ).subscribe());
    if (reload) {
      window.location.reload();
    }
  }
}

